import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconFilterGridProps extends SVGProps<any> {}
export class SVGIconFilterGrid extends Component<SVGIconFilterGridProps> {
  render() {
    const { width = 40, height = 40, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-filter-grid"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <g clipPath="url(#clip0_1300_174)">
          <mask
            id="mask0_1300_174"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="40"
            height="40"
          >
            <path d="M40 0H0V40H40V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_1300_174)">
            <mask
              id="mask1_1300_174"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="-3"
              width="20"
              height="26"
            >
              <path
                d="M19.5312 -2.1875H0.78125V22.0312H19.5312V-2.1875Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_1300_174)">
              <path
                d="M15.2344 0.839844H5.07812C3.93891 0.841445 2.8467 1.4267 2.04115 2.46721C1.23559 3.50771 0.782492 4.91848 0.78125 6.38998V13.4537C0.782492 14.9252 1.23559 16.336 2.04115 17.3766C2.8467 18.417 3.93891 19.0023 5.07812 19.0039H15.2344C16.3736 19.0023 17.4658 18.417 18.2713 17.3766C19.0769 16.336 19.53 14.9252 19.5312 13.4537V6.38998C19.53 4.91848 19.0769 3.50771 18.2713 2.46721C17.4658 1.4267 16.3736 0.841445 15.2344 0.839844ZM17.1875 13.4537C17.1875 14.1229 16.9817 14.7645 16.6155 15.2377C16.2491 15.7108 15.7523 15.9766 15.2344 15.9766H5.07812C4.56012 15.9766 4.06334 15.7108 3.69705 15.2377C3.33077 14.7645 3.125 14.1229 3.125 13.4537V6.38998C3.125 5.72089 3.33077 5.07921 3.69705 4.60609C4.06334 4.13298 4.56012 3.86719 5.07812 3.86719H15.2344C15.7523 3.86719 16.2491 4.13298 16.6155 4.60609C16.9817 5.07921 17.1875 5.72089 17.1875 6.38998V13.4537Z"
                fill="#513389"
              />
            </g>
            <mask
              id="mask2_1300_174"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="17"
              width="20"
              height="26"
            >
              <path
                d="M19.5312 17.9688H0.78125V42.1875H19.5312V17.9688Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_1300_174)">
              <path
                d="M15.2344 20.9961H5.07812C3.93891 20.9977 2.8467 21.583 2.04115 22.6234C1.23559 23.664 0.782492 25.0748 0.78125 26.5462V33.61C0.782492 35.0815 1.23559 36.4923 2.04115 37.5328C2.8467 38.5733 3.93891 39.1585 5.07812 39.1602H15.2344C16.3736 39.1585 17.4658 38.5733 18.2713 37.5328C19.0769 36.4923 19.53 35.0815 19.5312 33.61V26.5462C19.53 25.0748 19.0769 23.664 18.2713 22.6234C17.4658 21.583 16.3736 20.9977 15.2344 20.9961ZM17.1875 33.61C17.1875 34.2791 16.9817 34.9208 16.6155 35.3939C16.2491 35.867 15.7523 36.1328 15.2344 36.1328H5.07812C4.56012 36.1328 4.06334 35.867 3.69705 35.3939C3.33077 34.9208 3.125 34.2791 3.125 33.61V26.5462C3.125 25.8771 3.33077 25.2355 3.69705 24.7623C4.06334 24.2892 4.56012 24.0234 5.07812 24.0234H15.2344C15.7523 24.0234 16.2491 24.2892 16.6155 24.7623C16.9817 25.2355 17.1875 25.8771 17.1875 26.5462V33.61Z"
                fill="#513389"
              />
            </g>
            <mask
              id="mask3_1300_174"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="20"
              y="-3"
              width="20"
              height="26"
            >
              <path
                d="M39.2188 -2.1875H20.4688V22.0312H39.2188V-2.1875Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_1300_174)">
              <path
                d="M34.9219 0.839844H24.7656C23.6264 0.841445 22.5342 1.4267 21.7287 2.46721C20.9231 3.50771 20.47 4.91848 20.4688 6.38998V13.4537C20.47 14.9252 20.9231 16.336 21.7287 17.3766C22.5342 18.417 23.6264 19.0023 24.7656 19.0039H34.9219C36.0611 19.0023 37.1533 18.417 37.9588 17.3766C38.7644 16.336 39.2175 14.9252 39.2188 13.4537V6.38998C39.2175 4.91848 38.7644 3.50771 37.9588 2.46721C37.1533 1.4267 36.0611 0.841445 34.9219 0.839844ZM36.875 13.4537C36.875 14.1229 36.6692 14.7645 36.303 15.2377C35.9366 15.7108 35.4398 15.9766 34.9219 15.9766H24.7656C24.2477 15.9766 23.7509 15.7108 23.3845 15.2377C23.0183 14.7645 22.8125 14.1229 22.8125 13.4537V6.38998C22.8125 5.72089 23.0183 5.07921 23.3845 4.60609C23.7509 4.13298 24.2477 3.86719 24.7656 3.86719H34.9219C35.4398 3.86719 35.9366 4.13298 36.303 4.60609C36.6692 5.07921 36.875 5.72089 36.875 6.38998V13.4537Z"
                fill="#513389"
              />
            </g>
            <mask
              id="mask4_1300_174"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="20"
              y="17"
              width="20"
              height="26"
            >
              <path
                d="M39.2188 17.9688H20.4688V42.1875H39.2188V17.9688Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask4_1300_174)">
              <path
                d="M34.9219 20.9961H24.7656C23.6264 20.9977 22.5342 21.583 21.7287 22.6234C20.9231 23.664 20.47 25.0748 20.4688 26.5462V33.61C20.47 35.0815 20.9231 36.4923 21.7287 37.5328C22.5342 38.5733 23.6264 39.1585 24.7656 39.1602H34.9219C36.0611 39.1585 37.1533 38.5733 37.9588 37.5328C38.7644 36.4923 39.2175 35.0815 39.2188 33.61V26.5462C39.2175 25.0748 38.7644 23.664 37.9588 22.6234C37.1533 21.583 36.0611 20.9977 34.9219 20.9961ZM36.875 33.61C36.875 34.2791 36.6692 34.9208 36.303 35.3939C35.9366 35.867 35.4398 36.1328 34.9219 36.1328H24.7656C24.2477 36.1328 23.7509 35.867 23.3845 35.3939C23.0183 34.9208 22.8125 34.2791 22.8125 33.61V26.5462C22.8125 25.8771 23.0183 25.2355 23.3845 24.7623C23.7509 24.2892 24.2477 24.0234 24.7656 24.0234H34.9219C35.4398 24.0234 35.9366 24.2892 36.303 24.7623C36.6692 25.2355 36.875 25.8771 36.875 26.5462V33.61Z"
                fill="#513389"
              />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1300_174">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </SVG>
    );
  }
}
